import { Box, CircularProgress, Tab } from "@mui/material";
import { Suspense } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import SectionTabs from "./SectionTabs";

export type TabConfig = {
  title: string;
  pathname: string;
  element: (brandID: string) => React.ReactElement;
};

const TabContainer = ({
  brandID,
  tabs,
}: {
  brandID: string;
  tabs: TabConfig[];
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathParts = location.pathname.split("/").filter((part) => part !== "");
  const path = "/" + pathParts.join("/");
  const basePath = "/" + pathParts.slice(0, 2).join("/");
  const subPath = pathParts.slice(2).join("/");

  if (tabs.length === 1) {
    return tabs[0].element(brandID);
  }

  return (
    <Box sx={{ maxWidth: "100%", overflowX: "hidden" }}>
      <SectionTabs
        dense
        containerSx={{
          marginBottom: "32px",
          marginTop: "-32px",
          backgroundColor: "white",
        }}
        value={
          path === basePath
            ? `${basePath}/${tabs[0].pathname}`
            : basePath +
              "/" +
              tabs.find((config) => subPath.startsWith(config.pathname))
                ?.pathname
        }
        onChange={(_event, value) => {
          navigate(value);
        }}
      >
        {tabs.map((config) => {
          return (
            <Tab
              label={config.title}
              value={`${basePath}/${config.pathname}`}
              key={config.pathname}
            />
          );
        })}
      </SectionTabs>
      <Routes>
        <Route path={"/"} element={<Navigate to={tabs[0].pathname} />} />

        {tabs.map((config, index) => {
          return (
            <Route
              path={`${config.pathname}/*`}
              element={
                <Suspense
                  fallback={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  }
                >
                  {config.element(brandID)}
                </Suspense>
              }
              key={config.pathname}
            />
          );
        })}
      </Routes>
    </Box>
  );
};

export default TabContainer;
